import api from "./axios";

class ServiceNfse {
  async save(idNfse) {
    const { data } = await api.post("/nfse", idNfse)
    return data
  }

  async update(data) {
    await api.put(`/nfse/${data.id}`, data);
  }

  async updateStatus(id, status) {
    await api.patch(`/nfse/${id}`, status);
  }

  async delete(idNfse) {
    await api.delete(`/nfse/${idNfse}`)
  }

  async deleteAll(idNfse) {
    await api.delete(`/nfse/all/${idNfse}`)
  }

  async findById(id) {
    const { data } = await api.get(`/nfse/${id}`)
    return data;
  }

  async findByIdCompleted(id) {
    const { data } = await api.get(`/nfse/completed/${id}`)
    return data;
  }

  async search(text, type, page = 1, startDate, endDate, model = "os") {
    const { data } = await api.get(`/nfse?q=${encodeURIComponent(text)}&type=${type}&page=${page}&startDate=${startDate}&endDate=${endDate}&model=${model}`)
    return data;
  }

  async send(idNfse) {
    const { data } = await api.get(`/nfse/send/${idNfse}`)
    return data
  }

  async sendItem(idItem) {
    const { data } = await api.get(`/nfse/send/item/${idItem}`)
    return data
  }

  async cancelNfse(idNfse, motivo, idItem) {
    const { data } = await api.post(`/nfse/cancel/${idNfse}?idItem=${idItem}`, { motivo });
    return data;
  }

  async printNfse(id) {
    const { data } = await api.get(`/nfse/print/${id}`,
      {
        responseType: 'arraybuffer',
      }
    );

    const blob = new Blob([data], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(blob);

    return pdfUrl
  }
}
export default new ServiceNfse()